import useRevealOnce from "./useRevealOnce";

export default function LandingScrollCta({ onClick }) {
  const { elementRef, isRevealed } = useRevealOnce({
    rootMargin: "0px 0px -18% 0px",
    threshold: 0.18,
  });

  return (
    <div
      ref={elementRef}
      className={`landing-solution-cta ${
        isRevealed ? "landing-solution-cta--visible" : ""
      }`}
    >
      <button
        className="landing-button landing-button--primary"
        type="button"
        onClick={onClick}
      >
        Começar agora
      </button>
    </div>
  );
}
